// src/connection/hooks.ts
import { useConnectionMode } from './SimpleConnectionProvider';

export const useLiteMode = () => useConnectionMode() === 'lite';
export const useOfflineStatus = () => useConnectionMode() === 'offline';
// Add more as pure derivations:
export const useBalancedMode = () => useConnectionMode() === 'balanced';
export const useFullMode = () => useConnectionMode() === 'full';